import AlertPopup from "@/components/molecules/AlertPopup";
import { GlobalContext } from "@/contexts/SiteDataContext";
import dataLayer from "@/services/DataLayer";
import React, { useContext, useEffect } from "react";

const CLOSE_DATALAYER_KEY = "closePopupNotYourFormOver15";
const REDIRECT_DATALAYER_KEY = "redirectToD11FromPopupNotYourFormOver15";
const SHOWUP_DATALAYER_KEY = "showUpPopupNotYourFormOver15";

interface Over15AlertProps {
  onClose?: () => void;
}

const Over15Alert: React.FC<Over15AlertProps> = ({ onClose }) => {
  const { t } = useContext(GlobalContext).context;

  const handleOnClose = () => {
    dataLayer.push(CLOSE_DATALAYER_KEY);
    if (typeof onClose === "function") {
      onClose();
    }
  };

  const handleOnRedirect = () => {
    dataLayer.push(REDIRECT_DATALAYER_KEY);
  };

  useEffect(() => {
    dataLayer.push(SHOWUP_DATALAYER_KEY);
  }, []);

  return (
    <AlertPopup
      title={t["You applied for your last passport over 15 years ago."]}
      alertMessage={
        t[
          "If you entered the wrong issuing date simply correct the error and continue filling in the current form as normal."
        ]
      }
      onClose={handleOnClose}
      content={
        <span
          dangerouslySetInnerHTML={{
            __html:
              t[
                "<b>Remember:</b> You should use a DS-11 to complete your application if your last document is over 15 years old even if it isn’t your first passport."
              ],
          }}
        />
      }
      redirect={{
        to: "/new-passport",
        label: t["Go to DS-11"],
        onClick: handleOnRedirect,
      }}
    />
  );
};

export default Over15Alert;
